var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 264,
    viewBox: "0 0 423 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1026_412)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 264,
    fill: "#51DA4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689.868 -52.5785C689.868 -72.6935 706.174 -89 726.289 -89L877.578 -89C897.694 -89 914 -72.6935 914 -52.5785C914 -32.4634 897.694 -16.157 877.578 -16.157L726.289 -16.157C706.174 -16.157 689.868 -32.4635 689.868 -52.5785Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.421 135.132C252.306 135.132 236 118.826 236 98.7107L236 -52.5785C236 -72.6936 252.306 -89 272.422 -89C292.537 -89 308.843 -72.6935 308.843 -52.5785L308.843 98.7107C308.843 118.826 292.537 135.132 272.421 135.132Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M877.578 364.868C897.694 364.868 914 381.174 914 401.289L914 552.578C914 572.694 897.693 589 877.578 589C857.463 589 841.157 572.694 841.157 552.578L841.157 401.289C841.157 381.174 857.464 364.868 877.578 364.868Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.132 552.578C460.132 572.694 443.826 589 423.711 589L272.421 589C252.306 589 236 572.693 236 552.578C236 532.463 252.306 516.157 272.421 516.157L423.711 516.157C443.826 516.157 460.132 532.464 460.132 552.578Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236 98.7107C236 78.5957 252.306 62.2893 272.421 62.2893L423.711 62.2893C443.826 62.2893 460.132 78.5957 460.132 98.7108C460.132 118.826 443.826 135.132 423.711 135.132L272.421 135.132C252.306 135.132 236 118.826 236 98.7107Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M726.289 62.2893C746.404 62.2893 762.711 78.5957 762.711 98.7108L762.711 250C762.711 270.115 746.404 286.421 726.289 286.421C706.174 286.421 689.868 270.115 689.868 250L689.868 98.7107C689.868 78.5957 706.174 62.2893 726.289 62.2893Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M914 401.289C914 421.404 897.693 437.711 877.578 437.711L726.289 437.711C706.174 437.711 689.868 421.404 689.868 401.289C689.868 381.174 706.174 364.868 726.289 364.868L877.578 364.868C897.694 364.868 914 381.174 914 401.289Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.711 437.711C403.596 437.711 387.289 421.404 387.289 401.289L387.289 250C387.289 229.885 403.596 213.579 423.711 213.579C443.826 213.579 460.132 229.885 460.132 250L460.132 401.289C460.132 421.404 443.826 437.711 423.711 437.711Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M877.578 62.2893C897.694 62.2893 914 78.5957 914 98.7108C914 202.377 829.956 286.422 726.289 286.421C706.174 286.421 689.868 270.115 689.868 250C689.868 229.885 706.174 213.579 726.289 213.579C789.726 213.579 841.157 162.147 841.157 98.7107C841.157 78.5957 857.464 62.2893 877.578 62.2893Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.289 -52.5785C387.289 -72.6935 403.596 -89 423.711 -89C527.377 -89 611.421 -4.95562 611.421 98.7107C611.421 118.826 595.115 135.132 575 135.132C554.885 135.132 538.579 118.826 538.579 98.7107C538.579 35.2744 487.147 -16.157 423.711 -16.157C403.596 -16.157 387.289 -32.4635 387.289 -52.5785Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M762.711 552.578C762.711 572.694 746.404 589 726.289 589C622.623 589 538.578 504.956 538.579 401.289C538.579 381.174 554.885 364.868 575 364.868C595.115 364.868 611.421 381.174 611.421 401.289C611.421 464.726 662.853 516.157 726.289 516.157C746.404 516.157 762.711 532.464 762.711 552.578Z",
    fill: "#00002E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.421 437.711C252.306 437.711 236 421.404 236 401.289C236 297.623 320.044 213.578 423.711 213.579C443.826 213.579 460.132 229.885 460.132 250C460.132 270.115 443.826 286.421 423.711 286.421C360.274 286.421 308.843 337.853 308.843 401.289C308.843 421.404 292.537 437.711 272.421 437.711Z",
    fill: "#00002E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 423,
    height: 264,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgGreen);
export default __webpack_public_path__ + "static/media/bg_green.b4230f5320718c44a379f36fe35304f9.svg";
export { ForwardRef as ReactComponent };